// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cardd {
    box-sizing: border-box;
    width: 190px;
    height: 254px;
    background-color: white;
    border: 2px solid #642bff;
    box-shadow: 12px 17px 51px rgba(0, 0, 0, 0.22);
    -webkit-backdrop-filter: blur(6px);
            backdrop-filter: blur(6px);
    border-radius: 17px;
    text-align: center;
    cursor: pointer;
    transition: all 0.5s;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction:column;
    gap:30px;
    -webkit-user-select: none;
            user-select: none;
    font-weight: bolder;
    color: black;
  }
  
  .cardd:hover {
    border: 1px solid black;
    transform: scale(1.05);
  }
  
  .cardd:active {
    transform: scale(0.95) rotateZ(1.7deg);
  }
  .cimg{width:100px;height: 100px;}
  
 .arbtn {
    --color: #642bff;
    font-family: inherit;
    display: inline-block;
    width: 60px;
    height: 2.6em;
    line-height: 2.5em;
    overflow: hidden;
    margin: 20px;
    font-size: 17px;
    z-index: 1;
    color: var(--color);
    border: 2px solid var(--color);
    border-radius: 30px;
    position: relative;
  }
  
 .arbtn::before {
    position: absolute;
    content: "";
    background: var(--color);
    width: 150px;
    height: 200px;
    z-index: -1;
    border-radius: 50%;
  }
  
 .arbtn:hover {
    color: white;
  }
  
 .arbtn:before {
    top: 100%;
    left: 100%;
    transition: .3s all;
  }
  
 .arbtn:hover::before {
    top: -30px;
    left: -30px;
  }`, "",{"version":3,"sources":["webpack://./src/components/Cardd.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,yBAAyB;IACzB,8CAA8C;IAC9C,kCAA0B;YAA1B,0BAA0B;IAC1B,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,oBAAoB;IACpB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,qBAAqB;IACrB,QAAQ;IACR,yBAAiB;YAAjB,iBAAiB;IACjB,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,uBAAuB;IACvB,sBAAsB;EACxB;;EAEA;IACE,sCAAsC;EACxC;EACA,MAAM,WAAW,CAAC,aAAa,CAAC;;CAEjC;IACG,gBAAgB;IAChB,oBAAoB;IACpB,qBAAqB;IACrB,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,UAAU;IACV,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;EACpB;;CAED;IACG,kBAAkB;IAClB,WAAW;IACX,wBAAwB;IACxB,YAAY;IACZ,aAAa;IACb,WAAW;IACX,kBAAkB;EACpB;;CAED;IACG,YAAY;EACd;;CAED;IACG,SAAS;IACT,UAAU;IACV,mBAAmB;EACrB;;CAED;IACG,UAAU;IACV,WAAW;EACb","sourcesContent":[".cardd {\r\n    box-sizing: border-box;\r\n    width: 190px;\r\n    height: 254px;\r\n    background-color: white;\r\n    border: 2px solid #642bff;\r\n    box-shadow: 12px 17px 51px rgba(0, 0, 0, 0.22);\r\n    backdrop-filter: blur(6px);\r\n    border-radius: 17px;\r\n    text-align: center;\r\n    cursor: pointer;\r\n    transition: all 0.5s;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    flex-direction:column;\r\n    gap:30px;\r\n    user-select: none;\r\n    font-weight: bolder;\r\n    color: black;\r\n  }\r\n  \r\n  .cardd:hover {\r\n    border: 1px solid black;\r\n    transform: scale(1.05);\r\n  }\r\n  \r\n  .cardd:active {\r\n    transform: scale(0.95) rotateZ(1.7deg);\r\n  }\r\n  .cimg{width:100px;height: 100px;}\r\n  \r\n .arbtn {\r\n    --color: #642bff;\r\n    font-family: inherit;\r\n    display: inline-block;\r\n    width: 60px;\r\n    height: 2.6em;\r\n    line-height: 2.5em;\r\n    overflow: hidden;\r\n    margin: 20px;\r\n    font-size: 17px;\r\n    z-index: 1;\r\n    color: var(--color);\r\n    border: 2px solid var(--color);\r\n    border-radius: 30px;\r\n    position: relative;\r\n  }\r\n  \r\n .arbtn::before {\r\n    position: absolute;\r\n    content: \"\";\r\n    background: var(--color);\r\n    width: 150px;\r\n    height: 200px;\r\n    z-index: -1;\r\n    border-radius: 50%;\r\n  }\r\n  \r\n .arbtn:hover {\r\n    color: white;\r\n  }\r\n  \r\n .arbtn:before {\r\n    top: 100%;\r\n    left: 100%;\r\n    transition: .3s all;\r\n  }\r\n  \r\n .arbtn:hover::before {\r\n    top: -30px;\r\n    left: -30px;\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
